import * as matomo from './matomo'
import * as posthog from './posthog'

export function trackEvent(category, action, name = null, value = null, medium = null) {
  matomo.trackEvent(category, action, name, value, medium)
  posthog.trackEvent(category, action, { secondary: name, value, medium })
}

export function trackAnalyticsEvent(category, action, properties, name, value) {
  matomo.trackEvent(category, action, name, value)
  posthog.trackEvent(category, action, properties)
}
